/**
 * What each language is called, in its own words.
 *
 * One list rather than two: the preferences screen picks a person's language and the company
 * screen picks the tenant's default, and a language named differently on the two screens is a
 * product that looks assembled from parts.
 */
export const LOCALE_NAMES: Record<string, string> = {
  'pt-BR': '🇧🇷 Português (Brasil)',
  'en-US': '🇺🇸 English (US)',
  es: '🇪🇸 Español',
};
